import React from 'react';
import { shape } from 'prop-types';
import { CONSULT_PENDING } from 'Constants/consults';
import useDoctor from 'Hooks/teleconsult/useDoctor';

import useConsult from '../../../../../../hooks/useConsult';

import MessagePendingRequest from './MessagePendingRequest';
import MessageCompletedRequest from './MessageCompletedRequest';

const MessageRequestConsult = props => {
  const { message } = props;
  const {
    metadata: { consultId },
  } = message;
  const consult = useConsult(consultId);
  const {
    data: { id: doctorId },
  } = useDoctor();

  if (consult?.status === CONSULT_PENDING) {
    return <MessagePendingRequest message={message} consult={consult} doctorId={doctorId} />;
  }
  return <MessageCompletedRequest message={message} />;
};

MessageRequestConsult.propTypes = {
  message: shape({}).isRequired,
};

export default MessageRequestConsult;
